import React, { ReactElement, ReactNode } from 'react';
import {
  Tooltip as MUITooltip,
  TooltipProps as MUITooltipProps,
} from '@mui/material';

import colors from '@atom/styles/colors';

type CustomProps = {
  /**
   * lightTooltip will change basic styles for tooltip to
   * be a white background card
   */
  lightTooltip?: boolean;
};

type AtomMUIProps = {
  children: ReactElement<any>;
  title: ReactNode;
  disableHoverListener?: boolean;
  disableTouchListener?: boolean;
  placement?:
    | 'bottom'
    | 'left'
    | 'right'
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'left-end'
    | 'left-start'
    | 'right-end'
    | 'right-start'
    | 'top-end'
    | 'top-start';
};

export type Props = CustomProps & AtomMUIProps;

export const Tooltip = React.forwardRef((props: Props, ref: React.Ref<any>) => {
  const { children, lightTooltip = false, ...data } = props;

  const lightTooltipSx = {
    backgroundColor: colors.neutral.white,
    color: colors.neutral.black,
    boxShadow: '0px 2px 1px -1px rgba(0,0,0,0.2)',
    fontSize: 11,
    fontWeight: 'normal',
  };

  const MUIProps: Omit<MUITooltipProps, 'children'> = data;

  return (
    <MUITooltip
      {...MUIProps}
      slotProps={{ tooltip: { sx: lightTooltip ? lightTooltipSx : {} } }}
      ref={ref}
    >
      {children}
    </MUITooltip>
  );
});
